import React from 'react'

import { CustomTheme } from '@masfront/common-b2c'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { MainTitleHeader, Action } from '~/ui/components/MainTitleHeader'

const useStyles = makeStyles((theme: CustomTheme) => {
  return {
    root: {
      background: theme.palette.common.white,
    },
  }
})

interface B2CPageProps {
  title: React.ReactNode
  subtitle?: string
  headerActions?: Array<Action>
  goBackUrl?: string
  children: React.ReactNode
}

const B2CPage: React.FC<B2CPageProps> = ({
  title,
  subtitle,
  headerActions,
  goBackUrl,
  children,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <>
        <MainTitleHeader
          goBackUrl={goBackUrl}
          title={title}
          subtitle={subtitle}
          actions={headerActions}
        />
        <Box>{children}</Box>
      </>
    </Box>
  )
}

export default B2CPage
